<div class="flex flex-wrap items-center font-medium" *ngIf='crumbs && crumbs.length'>
    <div *ngFor='let crumb of crumbs; let first = first; let last = last'
         [ngClass]='{ active: last }' class="flex items-center">
        <ng-container *ngIf='!last; else lastBreadcrumb'>
            <a (click)='navigate(crumb.path)'
               class="whitespace-nowrap text-primary-500 cursor-pointer">{{ crumb.text }}</a>
            <mat-icon
                    class="icon-size-5 text-secondary"
                    [svgIcon]="'heroicons_solid:chevron-right'"></mat-icon>
        </ng-container>
        <ng-template #lastBreadcrumb>
            <a class="whitespace-nowrap text-primary-500">
                <span [innerHTML]='crumb.text'></span>
            </a>
        </ng-template>
    </div>

</div>


